import { Box } from '@mui/material';
import React from 'react';
import { SanitizedHtml } from './components/SanitizedHtml';
import { DisplayContent } from './styles/display.styles';
import type { RichTextDisplayProps } from './types';

export const RichTextDisplay = React.memo<RichTextDisplayProps>(
  ({ value, onClick, sx, className }) => {
    if (!value.trim()) {
      return null;
    }

    const handleClick = (e: React.MouseEvent) => {
      if( (e.target as HTMLElement).tagName.toLowerCase() === 'a' ) return;

      if (onClick) {
        onClick();
      }
    }

    return (
      <Box
        sx={{
          cursor: onClick ? 'pointer' : 'default',
          ...sx,
        }}
        className={className}
        onClick={handleClick}
      >
        <DisplayContent>
          <SanitizedHtml content={value} />
        </DisplayContent>
      </Box>
    );
  },
);
